import { apiGet, apiPost } from './index'

export type SubscriptionAdmin = {
  user_id: number
  display_name: string
  email: string
}

export type SubscriptionFeatureSeats = {
  base: number
  addon: number
  total: number
  assigned: number
  available: number
}

export type SubscriptionSeatSummary = {
  inbox: SubscriptionFeatureSeats
  prep: SubscriptionFeatureSeats
}

export type SubscriptionStation = {
  id: number
  name: string
  website_url: string | null
  website_domain: string | null
  subscription: {
    status: string | null
    current_period_end: string | null
    cancel_at_period_end: boolean
  }
  seats: SubscriptionSeatSummary | null
  admins: SubscriptionAdmin[]
}

export type SubscriptionOverviewResponse = {
  stations: SubscriptionStation[]
}

export type CreditPolicySettings = {
  included_monthly: number
  subscription_rollover_months: number
  pack_valid_months: number
}

export type YoutubeCostSettings = {
  audio: number
  video: number
}

export type ProductDefinition = {
  key: string
  group: 'individual' | 'station' | 'credits' | 'seat_addon'
  label: string
  description: string
  bullets: string[]
  active: boolean
}

export type SubscriptionSettingsResponse = {
  credit_policy: CreditPolicySettings
  youtube_costs: YoutubeCostSettings
  show_clock_free_enabled?: boolean
  products?: ProductDefinition[]
  product_groups?: string[]
  pricing_cache_ttl_hours?: number
  pricing_last_updated?: string | null
}

export type SubscriptionSettingsPayload = {
  credit_policy?: Partial<CreditPolicySettings>
  youtube_costs?: Partial<YoutubeCostSettings>
  show_clock_free_enabled?: boolean
  products?: ProductDefinition[]
  pricing_cache_ttl_hours?: number
  refresh_pricing?: boolean
}

export function getSuperadminSubscriptionOverview(): Promise<SubscriptionOverviewResponse> {
  return apiGet<SubscriptionOverviewResponse>('superadmin/subscriptions/overview')
}

export function getSuperadminSubscriptionSettings(): Promise<SubscriptionSettingsResponse> {
  return apiGet<SubscriptionSettingsResponse>('superadmin/subscriptions/settings')
}

export function saveSuperadminSubscriptionSettings(
  payload: SubscriptionSettingsPayload,
): Promise<SubscriptionSettingsResponse> {
  return apiPost<SubscriptionSettingsResponse>('superadmin/subscriptions/settings', payload)
}

export function updateStationAdminRole(payload: {
  station_id: number
  user_id: number
  role: 'admin' | 'presenter'
}): Promise<{ station_id: number; user_id: number; role: string }> {
  return apiPost<{ station_id: number; user_id: number; role: string }>('superadmin/subscriptions/admins', payload)
}
